import { useEffect, useState } from "react";
import {
  PREFERENCES_STORAGE_KEY,
  PREFERENCES_UPDATED_EVENT,
  UsagePlan,
  getUsagePlan,
} from "src/utils/preferences";

const useUsagePlan = (): UsagePlan => {
  const [usagePlan, setUsagePlan] = useState<UsagePlan>(() => getUsagePlan());

  useEffect(() => {
    const syncUsagePlan = () => {
      setUsagePlan(getUsagePlan());
    };

    const handlePreferencesUpdated = () => {
      syncUsagePlan();
    };

    const handleStorage = (event: StorageEvent) => {
      if (event.key === PREFERENCES_STORAGE_KEY) {
        syncUsagePlan();
      }
    };

    window.addEventListener(
      PREFERENCES_UPDATED_EVENT,
      handlePreferencesUpdated as EventListener
    );
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener(
        PREFERENCES_UPDATED_EVENT,
        handlePreferencesUpdated as EventListener
      );
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  return usagePlan;
};

export default useUsagePlan;
